import type React from "react";
import {memo} from "react";

import {Text} from "../ui/text";

interface Props {
    children: string;
}

const Token: React.FC<Props> = ({children}) => {
    return (
        <Text bold className="contents" color="blueGray.800" variant="sm">
            {children}
        </Text>
    );
};

export default memo(Token);
